<template>
	<div>
		<div class="slide photo1 zoom" ref="photo" v-parallax-fit="photo1"></div>
	</div>
</template>


<script>
import { store } from '../../store';

export default {
	name: 'slide26',
	created() {
		this.$watch('store.lang', newVal => {
			if(Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });
	},
	mounted() {
		const self = this;
		const evidence = {
			items: [
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/15.jpg',
					url: 'https://www.acceaction.org/about',
					link_title: {
						'en': 'ACCE Action',
						'es': 'ACCE Acción'
					}
				},
			],
			text: {
				'en': 'ACCE takes seriously its commitment to ground-up organizing to build a strong people’s movement that can create transformative community change. The organization\'s local neighborhood chapters and issue committees, led by ACCE Action member leaders, meet regularly to strategize and plan campaigns. Central to this work is the belief that there’s power in numbers and in collective action. To learn more, visit the ACCE website.',
				'es': 'ACCE toma en serio su compromiso con la organización desde cero para construir un movimiento popular fuerte que pueda crear un cambio comunitario transformador. Los capítulos de los vecindarios locales de la organización y los comités temáticos, dirigidos por los líderes de los miembros de ACCE Action, se reúnen regularmente para diseñar estrategias y planificar campañas. El centro de este trabajo es la creencia de que hay poder en los números y en la acción colectiva. Para obtener más información, visite el sitio web de ACCE.'
			}
		};
		const audio = '/themes/rise-theme/resources/assets/audio/vanessa/5.mp3';
		const text = {
			'en': 'The Alliance of Californians for Community Empowerment (ACCE) Action is a grassroots, member-led, statewide community organization working with more than 15,000 members across California. ACCE is dedicated to raising the voices of everyday Californians, neighborhood by neighborhood.',
			'es': 'La Acción de la Alianza de Californianos para el Empoderamiento de la Comunidad (ACCE) es una organización comunitaria de base, dirigida por sus miembros, en todo el estado que trabaja con más de 15,000 miembros en todo California. ACCE se dedica a elevar las voces de los californianos cotidianos, barrio por barrio.'
		};
		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.transform == 'translateX(0px) translateY(0px) rotate(0deg)') {
					self.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl[store.lang];
					self.$readMore.value = text;
					self.$evidence.value = JSON.stringify(evidence);
				}
			});
		});

		this.mutationObserver.observe(this.$refs.photo, {
			attributes: true,
			attributeFilter: ['style']
		});
	},
	unmounted() {
		this.mutationObserver.disconnect();
	},
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/vanessa/5.srt',
				'es': '/themes/rise-theme/resources/assets/audio/vanessa/5_es.srt'
			},
			mutationObserver: null,
			photo1: [
				{
					start: 33800,
					end: 34400,
					fromStyle: { transform: 'translateX(0px) translateY(-630px) rotate(0deg)' },
					toStyle: { transform: 'translateX(0px) translateY(0px) rotate(0deg)' }
				},
				{
					start: 34900,
					end: 35800,
					fromStyle: { transform: 'translateX(0px) translateY(0px) rotate(0deg)' },
					toStyle: { transform: 'translateX(-190px) translateY(270px) rotate(-6deg)' }
				},
				{
					start: 36500,
					end: 37000,
					fromStyle: { transform: 'translateX(-190px) translateY(270px) rotate(-6deg)' },
					toStyle: { transform: 'translateX(-190px) translateY(2200px) rotate(20deg)' }
				},
			],
		};
	}
}
</script>

<style lang="scss" scoped>
.photo1 {
	position: fixed;
	background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/26_photo1.png');
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
	width: 530px;
	height: 530px;
	transition: 0.3s;
	transform-origin: center;
	z-index: 5;
	left: -21vw;
	top: 10vh;

	@media(max-width: 600px) {
		left: 22px;
		width: 260px;
		height: 250px;
	}

	@media(max-width: 400px) {
		height: 210px;
		left: -78px;
		top: 12%;
		width: 260px;
	}
}
</style>
